/*
 * @Author: YCL
 * @LastEditors: yang chenglin
 * @Description: 路由配置
 */
import Cookie from 'js-cookie';
import NotFound from '@/components/NotFound';
import Home from '@/pages/Home';
import CustomerManagement from '@/pages/CustomerManagement';
import CrowdUpload from '@/pages/CustomerManagement/components/CrowdManage/userupload';
import CrowdTag from '@/pages/CrowdTags';
import NewCrowdTags from '@/pages/NewCrowdTags';
import PhoneUpload from '@/pages/PhoneUpload';

import yunLuCrowdTag from '@/pages/CrowdTagYunLu';
import OrderSelection from '@/pages/OrderSelection';
import OrderSelectionEffect from '@/pages/CrowdMarketing/components/Dialog_MarketingEffect_content';
import OrderSelectionCreateShortMesssage from '@/pages/OrderSelection/components/Dialog_CreateShortMesssage_content';
import CrowdMarketing from '@/pages/CrowdMarketing';
import CrowdMarketingCreate from '@/pages/CrowdMarketing/components/Dialog_CreateShortMesssage_content';
import PrivateCrowdMarketing from '@/pages/PrivateCrowdMarketing';
import PrivateMarketingCreate from '@/pages/PrivateCrowdMarketing/CreateTask';
import AccountKeeper from '@/pages/AccountKeeper';
import Alipay from '@/pages/AccountKeeper/components/SMSPayment/components/AliPay';
import AliPaySecond from '@/pages/AccountKeeper/components/SMSPayment/components/AliPay/index_second';
import OrdersCare from '@/pages/ordersCare';
import OrderPaymentCreate from '@/pages/ordersCare/components/OrderPaymentCreate';
import SMSTemplate from '@/pages/SMSTemplate';
import EffectData from '@/pages/EffectData';
import OrderCares from '@/pages/OrderCares';
import OrderCaresCreateTasks from '@/pages/OrderCares/CreateTasks/index';
import SMSConsumption from '@/pages/Sms/Consumption';

import CanvasTaskList from '@/pages/CanvasMarketing/Task';
import CanvasTaskEdit from '@/pages/CanvasMarketing/Edit';
import CanvasTaskAnalysis from '@/pages/CanvasMarketing/Analysis';

import PrivateAutoMarketingModel from '@/pages/PrivateAutoMarketingModel/index';
import MarketingModels from '@/pages/PrivateAutoMarketingModel/MarketingModels/index';
import CycleBuyingModels from '@/pages/PrivateAutoMarketingModel/CycleBuyingModels/index';

import GoodsManageList from '@/pages/GoodsManage/GoodsManageList';
import GoodsGroupManage from '@/pages/GoodsManage/GoodsGroupManage';

const routes = [
  {
    path: '/cjyx',
    exact: true,
    // component: lazy(() => import('@/pages/Home')),
    component: Home,
  },
  {
    path: '/customerManagement',
    exact: true,
    component: CustomerManagement,
  },
  {
    path: '/crowd/upload/',
    exact: true,
    component: CrowdUpload,
  },
  {
    // 标签形式创建人群(type-create)
    path: '/crowd/tag/:type',
    exact: true,
    component: CrowdTag,
  },
  {
    // 标签形式创建人群官方组合新
    path: '/crowd/newtag/create',
    exact: true,
    component: NewCrowdTags,
  },
  {
    // 手机上传人群包
    path: '/crowd/phoneUpload/create',
    exact: true,
    component: PhoneUpload,
  },
  {
    // 标签形式创建人群官方组合新
    path: '/crowd/newtag/copy',
    exact: true,
    component: NewCrowdTags,
  },
  {
    // 标签形式复制人群(type-copy，路由带着人群名称)
    path: '/crowd/tag/:type/:name',
    exact: true,
    component: CrowdTag,
  },
  {
    // 云鹿标签形式创建人群(type-create)
    path: '/yunLu/crowd/tag/:type',
    exact: true,
    component: yunLuCrowdTag,
  },
  {
    // 云鹿标签形式复制人群(type-copy，路由带着人群名称)
    path: '/yunLu/crowd/tag/:type/:name',
    exact: true,
    component: yunLuCrowdTag,
  },
  // 精准营销 - 订单筛选营销
  {
    path: '/orderSelection',
    exact: true,
    component: OrderSelection,
  },
  // 精准营销 - 订单筛选营销 - 营销效果
  {
    path: '/orderSelection/marketingEffect/:id',
    exact: true,
    component: OrderSelectionEffect,
  },
  // 精准营销 - 订单筛选营销 - 新建短信营销场景
  {
    path: '/orderSelection/createShortMesssage',
    exact: true,
    component: OrderSelectionCreateShortMesssage,
  },
  // 精准营销 -  官方人群营销
  {
    path: '/crowdMarketing',
    exact: true,
    component: CrowdMarketing,
  },
  // 精准营销 -  官方人群营销 - 新建
  {
    path: '/crowdMarketing/create',
    exact: true,
    component: CrowdMarketingCreate,
  },
  // 精准营销 -  云鹿人群营销
  {
    path: '/privateCrowdMarketing',
    exact: true,
    component: PrivateCrowdMarketing,
  },
  // 精准营销 -  云鹿人群营销 - 新建
  {
    path: '/privateCrowdMarketing/create',
    exact: true,
    component: PrivateMarketingCreate,
  },
  // 精准营销 - 云鹿人群营销 - 营销效果
  {
    path: '/privateCrowdMarketing/marketingEffect/:id',
    exact: true,
    component: OrderSelectionEffect,
  },
  // 账户管理
  {
    path: '/accountKeeper',
    exact: true,
    component: AccountKeeper,
  },
  {
    // 支付宝支付
    path: '/accountKeeper/sms/payDeal/ali/:price/:quantity/:firstChargeFlag',
    exact: true,
    component: Alipay,
  },
  {
    // 支付宝支付(等待支付的订单在充值记录里去付款)
    path: '/accountKeeper/sms/payDeal/ali/seconed/:outTradeNo',
    exact: true,
    component: AliPaySecond,
  },
  // 订单关怀页面
  {
    path: '/ordersCare',
    exact: true,
    component: OrdersCare,
  },
  // 订单关怀页面 - 订单催付 - 新建催付任务
  {
    path: '/order/mission',
    exact: true,
    component: OrderPaymentCreate,
  },
  // 关怀链路
  {
    path: '/order/care',
    exact: true,
    component: OrderCares,
  },
  {
    path: '/order/care/:type/:task/:taskId', // type: 查看 复制 新建 task: 订单催付 预售催付 ···
    exact: true,
    component: OrderCaresCreateTasks,
  },
  // 短信模板
  {
    path: '/smstemplate',
    exact: true,
    component: SMSTemplate,
  },
  // 短信消耗记录
  {
    path: '/sms/consumption',
    exact: true,
    component: SMSConsumption,
  },
  // 通用效果数据页
  // taskInstId-任务id
  {
    path: '/crowdMarketing/marketingEffect/task/:taskInstId',
    exact: true,
    component: EffectData,
  },
  // 画布任务列表页
  {
      path: '/canvas/activities',
      exact: true,
      component: CanvasTaskList
  },
  // 画布效果数据页 taskInstId-任务id
  {
    path: '/canvas/activities/task/:taskInstId',
    exact: true,
    component: EffectData,
  },
  // 画布编辑页
  {
      path: '/canvas/activities/:campaignId/:type',
      exact: true,
      component: CanvasTaskEdit
  },
  // 画布活动流程数据分析
  {
      path: '/canvas/activities/data/analysis/:id',
      exact: true,
      component: CanvasTaskAnalysis
  },
  /**
   * 自动化营销相关
   */
  {
    path: '/smsautomarket/marketing',
    exact: true,
    component: PrivateAutoMarketingModel,
  },
  {
      path: '/smsautomarket/marketing/create',
      exact: true,
      component: MarketingModels,
  },
  {
      path: '/smsautomarket/marketing/cycleCreate',
      exact: true,
      component: CycleBuyingModels,
  },
  // 商品管理
  {
    path: '/goodsManage/list',
    exact: true,
    component: GoodsManageList,
  },
  // 商品分组管理
  {
    path: '/goodsManage/group',
    exact: true,
    component: GoodsGroupManage,
  },
  {
    path: '/',
    exact: true,
    redirect: Cookie.get('shopId') === '13057269' ? '/crm/dashboard' : '/cjyx',
  },
  {
    component: NotFound,
    // wrappers: [BlankWrapper],
  }];

export default routes;
